export const ADDITION = 'addition';

export const MULTIPLICATION = 'multiplication';